import { Autocomplete, TextField } from "@mui/material";
import { Controller, Control } from "react-hook-form";
import { IwiData } from "@/interfaces/iwi";
import { getAsciiName } from "@/utils/textUtils";

interface IwiFieldProps {
  control: Control<any>;
  iwiList: IwiData[];
  selectedIwi: IwiData[];
  disabled?: boolean;
  onUserInput?: () => void;
}

export const IwiField: React.FC<IwiFieldProps> = ({
  control,
  iwiList,
  selectedIwi,
  disabled,
  onUserInput,
}) => {
  return (
    <Controller
      name="iwi"
      control={control}
      render={({ field }) => (
        <Autocomplete
          multiple
          disabled={disabled}
          value={selectedIwi}
          onChange={(_event, newValues) => {
            onUserInput?.();
            const newIwi = newValues.map((value) => value.id);
            field.onChange(newIwi);
          }}
          options={iwiList}
          getOptionLabel={(option) => option.name}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          filterOptions={(options, params) => {
            const inputValue = params.inputValue?.toLowerCase().trim();
            if (!inputValue) return [];
            const asciiInput = getAsciiName(inputValue);
            return options.filter((option) =>
              getAsciiName(option.name).includes(asciiInput)
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Iwi"
              placeholder="Search iwi"
              margin="normal"
            />
          )}
        />
      )}
    />
  );
};
